import { FC } from "react"
import type { UserFavoriteEvents } from "../../../pages/favorite/types"
import FavoriteItem from "../../StyledCard/FavoriteCard"


export type FavoriteEventListProps = {
  list: UserFavoriteEvents
  onChange: () => void;
}

export const FavoriteEventList: FC<FavoriteEventListProps> = ({
  list,
}) => {

  return (
    <>
      {list.length === 0 ? (
        <div
          style={{
            minWidth: "calc(100vw - 16px)",
            textAlign: "center",
            padding: "96px 0",
            color: "var(--Schemes-Primary)",
          }}
        >
          У вас нет избранных событий
        </div>
      ):(
              list.map((item) => (
          <FavoriteItem
            key={item.event_id}
            id={item.event_id}
            img={item.event_photo[0]}
            location={item.event_address.city}
            time={item.start_time!!}
            title={item.event_name}
            description={item.event_description}
          />
      ))
      )}
    </>
  )
}
